<template>
  <div id="allviews">
    <omnichannel-overview />
    <conversion-sales />
    <all-segment-groups />
    <customer-base />
    <web-site-behavior v-if="$experimental" />
  </div>
</template>

<script>
// libs
import bus from '@/helpers/events/bus';
import AllSegmentGroups from '@/views/dashboards-o2o/AllSegmentGroups';
import OmnichannelOverview from '@/views/dashboards-o2o/OmnichannelOverview';
import WebSiteBehavior from '@/views/dashboards-o2o/WebSiteBehavior';
import ConversionSales from '@/views/dashboards-o2o/ConversionSales';
import CustomerBase from '@/views/dashboards-o2o/CustomerBase';

export default {
  name: 'Allviews',
  components: {
    AllSegmentGroups,
    OmnichannelOverview,
    WebSiteBehavior,
    ConversionSales,
    CustomerBase,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      getLastCollapsedComponent: '',
    };
  },
  mounted() {
    this.getLastCollapsedComponent = 'Omnichanneloverview';
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth;
      });
    });
    bus.$on('render-cards', () => {
      bus.$emit('keep-last-collapsed-open', this.getLastCollapsedComponent);
    });
    bus.$on('is-active-collapse', id => {
      this.getLastCollapsedComponent = id;
    });
  },
  beforeUnmount() {
    bus.$off(['render-cards', 'is-active-collapse']);
  },
};
</script>
